import Vue from "vue";
import Vuex from "vuex";

//挂载Vuex
Vue.use(Vuex);

//创建VueX对象
const store = new Vuex.Store({
  state: {
    //存放的键值对就是所要管理的状态
    screenWidth: 0,
    screenHeight: 0,
    showTop: true,
    isMobile: false,
    orderDetails: sessionStorage.getItem("orderDetails")
      ? JSON.parse(sessionStorage.getItem("orderDetails"))
      : {},
    backgroundColor: "",
    orderConfig: {},
    showAccount: false, //进入orderInfo是否展示账户信息
    user: sessionStorage.getItem("user")
      ? JSON.parse(sessionStorage.getItem("user"))
      : ""
  },
  mutations: {
    //es6语法，等同edit:funcion(){...}
    edit_screenWidth(state, value) {
      state.screenWidth = value;
    },
    edit_showTop(state, value) {
      state.showTop = value;
    },
    edit_isMobile(state, value) {
      state.isMobile = value;
    },
    edit_screenHeight(state, value) {
      state.screenHeight = value;
    },
    edit_orderConfig(state, value) {
      state.orderConfig = value;
    },
    edit_orderDetails(state, value) {
      state.orderDetails = value;
      sessionStorage.setItem("orderDetails", JSON.stringify(value));
    },
    edit_backgroundColor(state, value) {
      state.backgroundColor = value;
      sessionStorage.setItem("backgroundColor", JSON.stringify(value));
    },
    edit_user(state, value) {
      state.user = value;
      if (value) {
        sessionStorage.setItem("user", JSON.stringify(value));
      } else {
        sessionStorage.removeItem("user");
      }
    },
    edit_showAccount(state, value) {
      state.showAccount = value;
      sessionStorage.setItem("showAccount", value);
    }
  }
});

export default store;
